<template>
  <v-container fluid class="pb100">
    <v-row justify="center">
      <v-col cols="12" md="9" lg="8" xl="7">
        <project-view
          :project="this.$store.state.projects.loaded_project"
        ></project-view>
      </v-col>
      <!-- <v-col cols="12" md="3" lg="3" xl="2">
        <v-row>
          <v-subheader class="font-weight-bold">Suggestions</v-subheader>
        </v-row>
        <v-row v-if="this.$store.state.projects.loading_suggestions">
          <v-col cols="12" v-for="i in 3" :key="'s' + i">
            <v-sheet :color="``" class="px-3">
              <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
            </v-sheet>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col
            cols="12"
            v-for="(project,i) in this.$store.state.projects.suggested_projects"
            :key="i"
          >
            <project-tile-mobile
              :project="project"
              v-if="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'"
            ></project-tile-mobile>
            <project-tile :project="project" v-else></project-tile>
          </v-col>
        </v-row>
      </v-col> -->
    </v-row>
  </v-container>
</template>
<script>
import projectView from "@/components/project/view";

// import projectTileMobile from "@/components/project/tile-mobile";
// import projectTile from "@/components/project/tile";

export default {
  name: "Project",
  metaInfo() {
    return {
      title: this.$store.state.projects.loaded_project
        ? this.$store.state.projects.loaded_project.title
        : null,
      meta: [
        {
          name: "description",
          content: this.$store.state.projects.loaded_project
            ? this.$store.state.projects.loaded_project.summary
            : null,
        },
        {
          name: "og:title",
          content: this.$store.state.projects.loaded_project
            ? this.$store.state.projects.loaded_project.title
            : null,
        },
        {
          name: "og:description",
          content: this.$store.state.projects.loaded_project
            ? this.$store.state.projects.loaded_project.summary
            : null,
        },
        {
          name: "og:image",
          content: this.$store.state.projects.loaded_project
            ? this.$store.state.projects.loaded_project.thumbnail_large
            : null,
        },
      ],
    };
  },
  data: () => ({
    frame_loaded: false,
  }),
  created() {},
  components: {
    projectView: projectView,
    // projectTileMobile: projectTileMobile,
    // projectTile: projectTile,
  },
  watch: {},
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      await vm.$store.dispatch("projects/load_project", to.params.id);
      vm.$meta().refresh();
    });
  },
  async beforeRouteUpdate(to, from, next) {
    this.name = to.params.name;
    await this.$store.dispatch("projects/load_project", to.params.id);
    this.$meta().refresh();
    next();
  },
  updated() {},
  methods: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
</style>
